// src/hooks/useRecaptcha.ts
import { useState, useEffect } from "react";
import { useToast } from "@/hooks/use-toast";

const RECAPTCHA_SITE_KEY = "6LePJWArAAAAAFhS2-d9lHkMzwPrFfzumfdsCswH"; // Use your actual site key

export function useRecaptcha() {
  const [isLoaded, setIsLoaded] = useState(false);
  const { toast } = useToast();

  useEffect(() => {
    if (window.grecaptcha) {
      setIsLoaded(true);
      return;
    }

    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SITE_KEY}`;
    script.async = true;
    script.defer = true;
    script.onload = () => setIsLoaded(true);
    script.onerror = () => {
      console.error("Failed to load reCAPTCHA script");
      toast({
        title: "reCAPTCHA Error",
        description: "Failed to load reCAPTCHA. Please refresh the page.",
        variant: "destructive",
      });
    };
    document.head.appendChild(script);

    return () => {
      const scriptElement = document.querySelector('script[src*="recaptcha"]');
      if (scriptElement) {
        scriptElement.remove();
      }
    };
  }, [toast]);

  return { isRecaptchaLoaded: isLoaded, siteKey: RECAPTCHA_SITE_KEY };
}
